var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 111,
    viewBox: "0 0 120 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6641 111C61.4089 111 63.9674 109.601 66.2357 108.143C98.4522 87.144 119.387 62.412 119.387 37.389C119.387 15.2238 103.976 0 85.1931 0C73.4461 0 64.8395 6.47429 59.6641 16.0399C54.6051 6.53237 45.8821 0 34.1935 0C15.3519 0 0 15.2238 0 37.389C0 62.412 20.935 87.144 53.1509 108.143C55.3608 109.601 57.9777 111 59.6641 111Z",
    fill: "#F5E9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1297 38.7024C83.1297 41.2776 81.0424 43.3649 78.4672 43.3649C75.892 43.3649 73.8047 41.2776 73.8047 38.7024C73.8047 36.1272 75.892 34.0399 78.4672 34.0399C81.0424 34.0399 83.1297 36.1272 83.1297 38.7024Z",
    fill: "#650D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8328 38.7025C45.8328 41.2777 43.7455 43.365 41.1703 43.365C38.5951 43.365 36.5078 41.2777 36.5078 38.7025C36.5078 36.1273 38.5951 34.04 41.1703 34.04C43.7455 34.04 45.8328 36.1273 45.8328 38.7025Z",
    fill: "#650D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6676 67.339C43.9474 67.339 43.238 67.0065 42.7811 66.3805C42.0229 65.34 42.2523 63.8817 43.2927 63.1235C48.2305 59.5251 54.0799 57.6233 60.2076 57.6233C65.9648 57.6233 71.5222 59.3199 76.277 62.53C77.3441 63.2503 77.6248 64.6997 76.9045 65.7667C76.1852 66.8338 74.7358 67.116 73.6682 66.3943C69.6865 63.7066 65.0324 62.2858 60.2076 62.2858C55.073 62.2858 50.1732 63.8788 46.0381 66.892C45.6237 67.194 45.1432 67.339 44.6676 67.339Z",
    fill: "#650D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemLiked);
export default __webpack_public_path__ + "static/media/noItemLiked.0d0c264f9505ffd635351d3833bfdddb.svg";
export { ForwardRef as ReactComponent };